export default __webpack_public_path__ + "static/ring11-b645b9f359f4e8b414b050719d89ee84.png";